const SubscriptionStatus = {
    EXPIRED: 0,
    ACTIVE: 1,
    SUSPENDED: 2,
    INACTIVE: 3,
    DELETED: 4,
};

export default SubscriptionStatus;
